export const VoucherArrow = () => {
  return (
    <div className="arrow-container">
      <div className="arrow-background animate-container">
        <svg
          className="animate-arrow"
          fill="none"
          height="24"
          viewBox="0 0 24 24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Default left-pointing arrow */}
          <path
            d="M19 12H5M5 12L12 19M5 12L12 5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </svg>
      </div>

      <style jsx>{`
        .arrow-background {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          background: white;
          border-radius: 50%;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          border: 1px solid #e0e0e0;
        }

        .animate-container {
          animation: bounceLeft 1.5s infinite ease-in-out;
        }

        @keyframes bounceLeft {
          0%,
          100% {
            transform: translateX(0);
          }
          50% {
            transform: translateX(-5px);
          }
        }

        @media (max-width: 768px) {
          .arrow-container {
            position: relative;
            right: auto;
            top: auto;
            transform: none;
            display: flex;
            justify-content: center;
            margin: 0 auto 45px;
            width: 100%;
          }

          .animate-container {
            transform: rotate(-90deg);
            animation: bounceDown 1.5s infinite ease-in-out;
          }

          @keyframes bounceDown {
            0%,
            100% {
              transform: rotate(-90deg) translateX(0);
            }
            50% {
              transform: rotate(-90deg) translateX(5px);
            }
          }
        }
      `}</style>
    </div>
  );
};
